var _rect, _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowDownBlack = function SvgArrowDownBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5833 28.9287C20.2546 29.2508 19.727 29.2455 19.4049 28.9168L13.5716 22.9645C13.2495 22.6358 13.2548 22.1081 13.5835 21.786C13.9122 21.4639 14.4398 21.4692 14.7619 21.7979L20.5952 27.7502C20.9174 28.0789 20.912 28.6065 20.5833 28.9287Z",
    fill: "#232528"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4167 28.9287C19.7454 29.2508 20.273 29.2455 20.5951 28.9168L26.4284 22.9645C26.7505 22.6358 26.7452 22.1081 26.4165 21.786C26.0878 21.4639 25.5602 21.4692 25.2381 21.7979L19.4048 27.7502C19.0826 28.0789 19.088 28.6065 19.4167 28.9287Z",
    fill: "#232528"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10.8335C20.4603 10.8335 20.8334 11.2066 20.8334 11.6668L20.8334 28.3333C20.8334 28.7935 20.4603 29.1666 20 29.1666C19.5398 29.1666 19.1667 28.7935 19.1667 28.3333L19.1667 11.6668C19.1667 11.2066 19.5398 10.8335 20 10.8335Z",
    fill: "#232528"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowDownBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-down-black.f50942ed.svg";
export { ForwardRef as ReactComponent };